import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'user-domain',
    template: require('./user-domain.component.html')
})
export class UserDomainComponent {
    @Input() public domain: any;
    @Output() public onRemoveDomain = new EventEmitter();
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users/user-domain/user-domain.component.ts